var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-body" },
    [
      _c("progress-bar"),
      _vm._v(" "),
      _vm.isWsReady
        ? [
            _c(
              "div",
              {
                staticClass: "chat-scroll-body",
                class: { "open-chat": _vm.isShowingOpenChat },
                on: {
                  "&scroll": function ($event) {
                    return _vm.handleScroll()
                  },
                },
              },
              [
                _vm._l(_vm.messageGroups, function (group, groupIndex) {
                  return _c(
                    "div",
                    { key: groupIndex, staticClass: "message-group" },
                    _vm._l(group, function (msg, index) {
                      return _c("message-item", {
                        key: index,
                        attrs: {
                          "data-message-id": msg.id,
                          "data-message-payload": msg.payload || msg.id,
                          message: msg,
                          "message-group": group,
                          "is-last-message-group":
                            groupIndex === _vm.messageGroups.length - 1,
                        },
                      })
                    }),
                    1
                  )
                }),
                _vm._v(" "),
                !_vm.messages.autoScroll && _vm.messages.unreadMessagesCount > 0
                  ? _c("div", { staticClass: "scroll-down-container" }, [
                      _c("span", { staticClass: "notification-counter" }, [
                        _vm._v(_vm._s(_vm.messages.unreadMessagesCount)),
                      ]),
                      _vm._v(" "),
                      _c("a", {
                        staticClass: "scroll-down-button",
                        attrs: {
                          tabindex: "0",
                          "aria-label": _vm.$t(
                            "chatbot.scrollToTheLatestMessage"
                          ),
                        },
                        on: {
                          click: _vm.scrollDown,
                          keydown: [
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.scrollDown.apply(null, arguments)
                            },
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "space",
                                  32,
                                  $event.key,
                                  [" ", "Spacebar"]
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.scrollDown.apply(null, arguments)
                            },
                          ],
                        },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.messageGroups.length === 0
                  ? _c("div", { staticClass: "message-group" })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isShowingOpenChat ? _c("typing-indicator") : _vm._e(),
                _vm._v(" "),
                _vm.isLastMessageStreamed
                  ? _c("div", { staticClass: "auto-scroll-anchor" })
                  : _vm._e(),
              ],
              2
            ),
          ]
        : [_c("loading")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }